import { ImageInformation } from "./ImageInformation";
import { ProductPricing } from "./Product";

export enum CampaignProductSelectionType {
  None = "None",
  AllProducts = "AllProducts",
  ProductCombinations = "ProductCombinations",
  SelectedProducts = "SelectedProducts"
}

export enum CampaignDiscountType {
  None = "None",
  Percentage = "Percentage",
  FixedPrice = "FixedPrice",
  FixedDiscount = "FixedDiscount"
}

export enum CampaignTargetUserType {
  None = "None",
  Segments = "Segments",
  Stores = "Stores"
}

export enum CampaignOfferType {
  None = "None",
  ProductCombinations = "ProductCombinations",
  ShoppingCartAmount = "ShoppingCartAmount",
  VolumeDiscount = "VolumeDiscount",
  SingleProduct = "SingleProduct"
}

export interface CampaignProduct {
  id: string;
  name: string;
  pricing?: ProductPricing;
}

export interface SingleProductOffer {
  product: CampaignProduct;
  price?: number;
  minimumPurchaseQuantity?: number;
  minimumPurchaseAmount?: number;
  maximumPurchaseQuantity?: number;
  inCombinationWith?: SingleProductOffer[];
}

export interface ProductCombinationOffer {
  id: string;
  price?: number;
  numberOfCombinations: number;
  englishTitleTranslation: string;
  englishDescriptionTranslation: string;
  swedishTitleTranslation: string;
  swedishDescriptionTranslation: string;
  image: ImageInformation;
  products: CampaignProduct[];
  inCombinationWith: CampaignProduct[];
  hasContent?: boolean;
  minimumPurchaseAmount?: number;
  maximumPurchaseQuantity?: number;
  maximumPurchaseCount?: number;
}

export interface NonActivatedCampaignProduct {
  externalProductId: string;
}

export interface CampaignDiscount {
  type: CampaignDiscountType;
  amount?: number;
}

export interface Campaign {
  id: string;
  name: string;
  active: boolean;
  englishTranslation: string;
  swedishTranslation: string;
  productSelectionType: CampaignProductSelectionType;
  offerType: CampaignOfferType;
  discount: CampaignDiscount;
  singleProductOffers: SingleProductOffer[];
  productCombinationOffers: ProductCombinationOffer[];
  nonActivatedProducts: NonActivatedCampaignProduct[];
  targetUserType: CampaignTargetUserType;
  stores: string[];
  segments: string[];
  start: Date;
  end: Date;
}

export interface SetupCampaign {
  name: string;
  englishTranslation: string;
  swedishTranslation: string;
  productSelectionType: CampaignProductSelectionType;
  offerType?: CampaignOfferType;
  discount: CampaignDiscount;
  singleProductOffers: SingleProductOffer[];
  productCombinationOffers: ProductCombinationOffer[];
  nonActivatedProducts: NonActivatedCampaignProduct[];
  targetUserType: CampaignTargetUserType;
  stores: string[];
  segments: string[];
  start: Date;
  end: Date;
}

export interface CampaignInventoryItem {
  id: string;
  gtin: string;
  name: string;
  brandName: string;
  size: string;
  price: number;
  minimumPurchaseAmount?: number;
}

export interface RouteProps {
  campaignId: string;
}
